import { catchError, filter, finalize, of, retry, Subscription } from 'rxjs';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    Inject,
    OnInit,
    Renderer2,
    ViewChild,
} from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { GlobalService } from 'src/app/_services/global.service';
import { SignupService } from 'src/app/_services/signup.service';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { WhiteLabelList } from 'src/app/_data/white-label-list';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { UsStates } from 'src/app/_data/us-states';
import { UserService } from 'src/app/_services/user.service';
import { isSubscription } from 'rxjs/internal/Subscription';



declare const Stripe;
@Component({
    selector: 'app-new-billing-plans',
    templateUrl: './new-billing-plans.component.html',
    styleUrls: ['./new-billing-plans.component.scss'],
})
export class NewBillingPlansComponent implements OnInit {
    _globals = GlobalService;

    addressForm: FormGroup;
    shippingForm: FormGroup;
    discount: number = 0.0;
    applyDiscount: string = null;
    discountValue: string = null;
    applyCouponBtnDisable = true;
    inValidCode: boolean = false;
    isLoading: boolean = false;
    isDiscountAllowed = false;
    isShowHardwareDetail: boolean = false;
    selectHardware: any = null;
    isBusinessAddressisShippingAddress = true;
    totalRegistersPrice = 0;
    totalLocationsPrice = 0;
    totalHaredwarePrice = 0;
    selectedAddons = [];
    totalPlanCost: number = 0;
    subTotal: number = 0.0;
    taxAmount: number = 0;
    grandTotal: number = 0.0;
    subTotalWithoutDiscount: number = 0.0;
    subTotalWithDiscount: number = 0.0;
    discountedSubscriptionPlanPrice: number = 0.0;
    taxRate = 0;

    showCityWait = false;
    showSCityWait = false;
    usaStates = UsStates;
    selectedState: any = null;
    selectedSState: any = null;
    hardwaresList: any[] = [];
    hardwaresListByPackage: any[] = [];
    isShowRegistersAndLocations = false;
    isShowHardware = false;
    registersAndLocationsList: any[] = [
        { id: 1, name: 'Registers', price: 49, quantity: 1 , withTaxPrice: 0},
        { id: 2, name: 'Locations', price: 79, quantity: 1  , withTaxPrice: 0},
    ];

    isUserLogin = false;

    plans: any[] = [];
    selectedPlans: any[] = [];

    item: any = true;
    hasSelectedPlan = false;
    selectedPlanUrl: string | null = null;

    isFreeSubscription: boolean = false;
    showHardwares: boolean = false;
    consentCheckBox : boolean = false;
    stateValue: string = '';
    constructor(
        public _signup: SignupService,
        private _userServices: UserService,
        private _fb: FormBuilder,
        private _spinner: NgxSpinnerService,
        private _router: Router,
        private _abd: AppBaseDataService,
        private route: ActivatedRoute,
        private cd: ChangeDetectorRef,
        private _connMessageService: ConnMessageService
    ) {}

    get getselectedAddons() {
        if (this._signup.selectedPlans?.length > 0)
            return this._signup.selectedPlans[0].addons.filter(
                (item) => item.selected && !item.defaultAddedInSubscription
            );
    }

    get bf() {
        return this.addressForm.controls;
    }
    get sf() {
        return this.shippingForm.controls;
    }
    private _old: any[] = [];
    ngDoCheck() {
        if (this._signup.selectedPlans !== this._old) {
            if(this._signup.selectedPlans == null){
                this._signup.selectedPlans = this._old;

            }

            this._old = this._signup.selectedPlans;

        }
    }

    ngOnInit(): void {
        this.initForm();
        this.getHardwareList();

        let currentUser = localStorage.getItem('user');
        if (currentUser !== null) {
            this.isUserLogin = true;
        } else {
            this.isUserLogin = false;
        }

        // {
        //     id: 1,
        //     planName: 'Free',
        //     selected: false,
        //     detail: 'For Starters, Artists & Artisans',
        //     isMonthly: true,
        //     allowPaidTrial: true,
        //     trialPrice: 0.0,
        //     trialMonth: 0,
        //     monthlyPrice: 0,
        //     yearlyPrice: 0,
        //     isSubscription: true,
        //     defaultLocation:1,
        //     defaultRegister:1,
        //     addons: [
        //         {
        //             id: 9,
        //             planName: 'POS Lite',
        //             selected: true,
        //             detail: 'POS Lite',
        //             isMonthly: true,
        //             allowPaidTrial: false,
        //             trialPrice: 0.0,
        //             trialMonth: 0,
        //             monthlyPrice: 0,
        //             yearlyPrice: 0,
        //             isAddon: true,
        //             defaultAddedInSubscription: true,
        //         },
        //     ],
        //     freeSubscription: true,
        // },
        this.plans = [
            {
                id: 2,
                planName: 'Standard',
                selected: false,
                detail: 'For Solo Entrepreneurs',
                isMonthly: true,
                allowPaidTrial: true,
                trialPrice: 0,
                trialMonth: 0,
                monthlyPrice: 35,
                yearlyPrice: 25,
                isSubscription: true,
                defaultLocation:1,
                defaultRegister:1,
                withTaxPrice: 0,
                addons: [
                    // {
                    //     id: 9,
                    //     planName: 'POS Lite',
                    //     selected: true,
                    //     detail: 'POS Lite',
                    //     isMonthly: true,
                    //     allowPaidTrial: false,
                    //     trialPrice: 0.0,
                    //     trialMonth: 0,
                    //     monthlyPrice: 0,
                    //     yearlyPrice: 0,
                    //     isAddon: true,
                    //     defaultAddedInSubscription: true,
                    // },
                    {
                        id: 5,
                        planName: 'Advanced Loyalty Program',
                        selected: false,
                        detail: 'Advanced Loyalty Program',
                        isMonthly: true,
                        allowPaidTrial: false,
                        trialPrice: 0.0,
                        trialMonth: 0,
                        monthlyPrice: 49,
                        yearlyPrice: 49,
                        isAddon: true,
                        defaultAddedInSubscription: false,
                        withTaxPrice: 0,
                    },

                ],
                freeSubscription: false,
            },
            // {id:2,planName:"POS-Mobile", selected:false,  detail:"Best for small businesses that need quick pos",isMonthly:true, monthlyPrice:99 , yearlyPrice:99},
            {
                id: 3,
                planName: 'Premium',
                selected: false,
                detail: 'For Small Teams',
                isMonthly: true,
                allowPaidTrial: true,
                trialPrice: 0,
                trialMonth: 0,
                monthlyPrice: 85,
                yearlyPrice: 75,
                defaultLocation:1,
                defaultRegister:1,
                isSubscription: true,
                withTaxPrice: 0,
                addons: [

                    // {
                    //     id: 8,
                    //     planName: 'Custom Online Store',
                    //     selected: false,
                    //     detail: 'Branded, customized Customer Shopping App',
                    //     isMonthly: true,
                    //     allowPaidTrial: false,
                    //     trialPrice: 0.0,
                    //     trialMonth: 0,
                    //     monthlyPrice: 199,
                    //     yearlyPrice: 199,
                    //     isAddon: true,
                    //     defaultAddedInSubscription: false,
                    // },
                    {
                        id: 5,
                        planName: 'Advanced Loyalty Program',
                        selected: false,
                        detail: 'Advanced Loyalty Program',
                        isMonthly: true,
                        allowPaidTrial: false,
                        trialPrice: 0.0,
                        trialMonth: 0,
                        monthlyPrice: 49,
                        yearlyPrice: 49,
                        isAddon: true,
                        defaultAddedInSubscription: false,
                        withTaxPrice: 0,
                    },

                ],
                freeSubscription: false,
            },
            {
                id: 4,
                planName: 'Advanced',
                selected: false,
                detail: 'For Chain Stores',
                isMonthly: true,
                allowPaidTrial: true,
                trialPrice: 0,
                trialMonth: 0,
                monthlyPrice: 295,
                yearlyPrice: 275,
                defaultLocation:2,
                defaultRegister:4,
                isSubscription: true,
                withTaxPrice: 0,
                addons: [

                    // {
                    //     id: 8,
                    //     planName: 'Custom Online Store',
                    //     selected: false,
                    //     detail: 'Branded, customized Customer Shopping App',
                    //     isMonthly: true,
                    //     allowPaidTrial: false,
                    //     trialPrice: 0.0,
                    //     trialMonth: 0,
                    //     monthlyPrice: 199,
                    //     yearlyPrice: 199,
                    //     isAddon: true,
                    //     defaultAddedInSubscription: false,
                    // },
                    {
                        id: 5,
                        planName: 'Standard Customer App',
                        selected: false,
                        detail: 'Sell In-Store, comes with free Online Store',
                        isMonthly: true,
                        allowPaidTrial: false,
                        trialPrice: 0.0,
                        trialMonth: 0,
                        monthlyPrice: 459,
                        yearlyPrice: 429,
                        isAddon: true,
                        withTaxPrice: 0,
                        defaultAddedInSubscription: false,
                    }
                ],
                freeSubscription: false,
            },
            // {id:5,planName:"Enterprise", selected:false,  detail:"If you are looking for a custom solution",isMonthly:true, monthlyPrice:999 , yearlyPrice:999,CTA:"contact"},
        ];

        let isRedirect = sessionStorage.getItem('is-Redirect');
        let businessData = sessionStorage.getItem('requiredInfo');

        if (businessData !== null) {
            this._signup.businessData = JSON.parse(businessData);
            this._signup.accountVerified = true
        }


        if (isRedirect === null || isRedirect !== 'Yes') {
            this._router.navigate(['signup/personal-info']);
        }

        if(!this.hasSelectedPlan){
            this._userServices.triggerCheckout();
        }


        const loadDataForBackPage = sessionStorage.getItem('back-to-personal');
        if (loadDataForBackPage !== null) {
            this._signup.selectedPlans = JSON.parse(sessionStorage.getItem('checkout-signup-subscription'))
           // this._signup.selectedPlans[0]?.addons = selectedPlan.addons.filter(f=> !f.defaultAddedInSubscription)
            // if(this._signup.selectedPlans[0]?.addons.length > 0){

            //     this.isShowRegistersAndLocations = this._signup.selectedPlans[0].addons.filter(f =>
            //         ['POS Lite','POS Pro'].includes(f.planName)
            //     ).length > 0 ? true : false;

            //    this.showHardwares = this.isShowRegistersAndLocations
            // }

            this.isShowRegistersAndLocations = false;
            this.showHardwares = false;
            this._signup.selectedPlans[0].addons =  this._signup.selectedPlans[0]?.addons.filter(f=> !f.defaultAddedInSubscription)
            if(this._signup.selectedPlans[0]?.id > 2){
                this.isShowRegistersAndLocations = true;
                this.showHardwares = true;
            }


            this.registersAndLocationsList = JSON.parse(sessionStorage.getItem('registersAndLocationsList'))
            this._signup.selectedHardware = JSON.parse(sessionStorage.getItem('selected-hardwares'))
            // const uniqueAddonsList = new Set(this._signup.selectedPlans[0]?.addons.map(item => item.planName));
            //     this.hardwaresList = this.hardwaresListByPackage.filter(f =>
            //         uniqueAddonsList.has(f.hardwareFor)
            //     )
            this.updateValues();
            sessionStorage.removeItem('back-to-personal');
        }

        const selectedPlanFromLincSell = sessionStorage.getItem('selected_plan_id');
        if (selectedPlanFromLincSell !== null) {

            this._signup.selectedPlanInterval =  'Monthly';

            const url_plan_interval = sessionStorage.getItem('url_plan_interval');
            this._signup.selectedPlanInterval = (url_plan_interval == "m") ? "Monthly" : "Yearly";
            this._signup.selectedPlans = this.plans.filter(f=> f.id == JSON.parse(selectedPlanFromLincSell) )
            this._signup.selectedPlans[0].addons =  this._signup.selectedPlans[0]?.addons.filter(f=> !f.defaultAddedInSubscription)
            this.isShowRegistersAndLocations = false;
            this.showHardwares = false;
            if(this._signup.selectedPlans[0]?.id > 2){
                this.isShowRegistersAndLocations = true;
                this.showHardwares = true;
            }
            if(this._signup.selectedPlans[0]?.addons.length > 0){

                // this.isShowRegistersAndLocations = this._signup.selectedPlans[0].addons.filter(f =>
                //     ['POS Lite','POS Pro'].includes(f.planName)
                // ).length > 0 ? true : false;
                // this.showHardwares = this.isShowRegistersAndLocations
                // const uniqueAddonsList = new Set(this._signup.selectedPlans[0]?.addons.map(item => item.planName));
                // this.hardwaresList = this.hardwaresListByPackage.filter(f =>
                //     uniqueAddonsList.has(f.hardwareFor)
                // )

            }
        }

        if(!this.hasSelectedPlan){
            this._userServices.checkoutCall$.subscribe((res) => {
                setTimeout(() => {
                    console.log(this._userServices);
                    this.updateValues();
                }, 500);
            })
        }
           // this code will get the selected plan from the url and set it to the selected plan in the component
        this.route.queryParams
        .subscribe(params => {
            // check if the param is present

            this.hasSelectedPlan = params.hasOwnProperty('selectedplan');
            let isFirstTime =  (sessionStorage.getItem('url_plan_selected_billing') === undefined ||
            sessionStorage.getItem('url_plan_selected_billing') === null) ? true : false

            if (this.hasSelectedPlan && isFirstTime) {
                // grab its value
                this.selectedPlanUrl = params['selectedplan'];

                if(sessionStorage.getItem('selected_plan_id') != undefined){
                    this.selectedPlanUrl = sessionStorage.getItem('selected_plan_id')
                }


                if(this.plans.find(t=>t.id == this.selectedPlanUrl) != undefined){
                    sessionStorage.setItem('url_plan_selected_billing', "1");
                    this._signup.selectedPlanInterval =  'Monthly';

                    const url_plan_interval = sessionStorage.getItem('url_plan_interval');
                    this._signup.selectedPlanInterval = (url_plan_interval == "m") ? "Monthly" : "Yearly";
                    let tempSelectedPlan = this.plans.find(t=>t.id == this.selectedPlanUrl);

                    this.selectPlan(tempSelectedPlan);
                    sessionStorage.setItem('plan_selected_using_url', JSON.stringify(tempSelectedPlan));
                    this._signup.selectedPlans = [...this._signup.selectedPlans];
                    this.cd.markForCheck();
                }
            }
        });


        // A plain page reload recreates SignupService, so _signup.selectedPlans (and any
        // in-memory addon/checkbox selections) is empty even though the same selections were
        // already written to sessionStorage on every toggle (selectAddon()/selectPlan() etc).
        // The 'back-to-personal'/'selected_plan_id' branches above only rehydrate it for their
        // own specific navigation cases, so a bare reload otherwise never restores it here.
        if (
            (!this._signup.selectedPlans || this._signup.selectedPlans.length === 0)
        ) {
            const persistedSubscription = sessionStorage.getItem('checkout-signup-subscription');
            if (persistedSubscription) {
                try {
                    this._signup.selectedPlans = JSON.parse(persistedSubscription);
                } catch {
                    /* ignore malformed sessionStorage value */
                }
            }
        }

        if (
            this._signup.selectedPlans &&
            this._signup.selectedPlans?.length > 0
        ) {

            this.plans.forEach((plan) => {
                plan.selected = this._signup.selectedPlans.some(
                    (selectedPlan) => selectedPlan.id === plan.id
                );
            });

            const planSelected = sessionStorage.getItem('checkout-signup-subscription');

           setTimeout(() => {
            if(planSelected){
                this._signup.selectedPlans[0].addons =  JSON.parse(sessionStorage.getItem('checkout-signup-subscription'))[0].addons
                this._signup.selectedPlans[0].addons =  this._signup.selectedPlans[0]?.addons.filter(f=> !f.defaultAddedInSubscription)
                this.calculate();
            }
           }, 200);


            this.registersAndLocationsList.forEach((reg) => {
                const selectedItem =
                    this._signup.selectedLocationsAndRegistersList.find(
                        (selected) => selected.id === reg.id
                    );
                reg.quantity = selectedItem ? selectedItem.quantity : 1;


            });
            // if(this._signup.selectedPlans[0]?.addons.length > 0){

            //     this.isShowRegistersAndLocations = this._signup.selectedPlans[0].addons.filter(f =>
            //         ['POS Lite','POS Pro'].includes(f.planName)
            //     ).length > 0 ? true : false;
            //     this.showHardwares = this.isShowRegistersAndLocations
            // }
            this.isShowRegistersAndLocations = false;
            this.showHardwares = false;
            if(this._signup.selectedPlans[0]?.id > 2){
                this.isShowRegistersAndLocations = true;
                this.showHardwares = true;
            }
            this.calculate();
        }


        this._router.events
        .pipe(filter(evt => evt instanceof NavigationStart))
        .subscribe((evt: NavigationStart) => {
            console.log(evt.url)

            if( (evt.url == "/pages/signin" || evt.url == "/subscription-plan-selection") && (this._globals.userInfo)){
                console.log('Navigated to sign-in page');
                this._router.navigate(['signup/personal-info'])
            }
        });

      // 2. On load, detect if this load was a reload vs fresh navigation
      const navEntry = (performance.getEntriesByType('navigation')[0] ||
                        performance as any).type;
      // older browsers use performance.navigation.type (0 = nav, 1 = reload)
      const navType = typeof navEntry === 'string'
        ? navEntry
        : ['navigate','reload','back_forward','reserved'][navEntry] || 'navigate';

      if (navType === 'reload') {
        const currentUrl = this._router.url;
        if (currentUrl.startsWith('/signup') || currentUrl.startsWith('/checkout')) {

        }
      } else {

      }
    }

    // @HostListener('window:beforeunload', ['$event'])
    // onBeforeUnload(event: BeforeUnloadEvent) {
    //     this.setSessionValues()

    //   event.returnValue = 'Are you sure you want to leave?';
    // }

    updateValues() {
        if (this._signup.selectedPlans.length > 0) {


            this.plans.forEach((plan) => {
                plan.selected = this._signup.selectedPlans.some(
                    (selectedPlan) => selectedPlan.id === plan.id
                );

                if (plan.selected) {

                    plan.addons = this._signup.selectedPlans[0].addons
                    plan.addons  =  plan.addons.filter(f=> !f.defaultAddedInSubscription)
                    // plan.addons.forEach((addon) => {
                    //     if(addon.selected && (addon.planName == 'POS Pro' || addon.planName == 'POS Lite' )) {
                    //         this.isShowRegistersAndLocations = addon.selected;
                    //     }
                    // });

                    // if (plan.addons.filter(f => f.defaultAddedInSubscription  ).length > 0) {

                    //     this.isShowRegistersAndLocations = plan.selected;
                    // }
                    if(plan.id > 2){
                        this.isShowRegistersAndLocations = true;
                        this.showHardwares = true;
                    }
                }
            });

            this.registersAndLocationsList.forEach((reg) => {
                const selectedItem =
                    this._signup.selectedLocationsAndRegistersList.find(
                        (selected) => selected.id === reg.id
                    );
                reg.quantity = selectedItem ? selectedItem.quantity : 1;
            });
            this.hardwaresList.forEach((hardware) => {
                const selectedItem = this._signup.selectedHardware.find(
                    (selected) => selected.id === hardware.id
                );
                hardware.selectedQuantity = selectedItem
                    ? selectedItem.selectedQuantity
                    : 0;
            });
            // const uniqueAddonsList = new Set(  plan.addons =  this._signup.selectedPlans[0]?.addons.filter(f=> !f.defaultAddedInSubscription).map(item => item.planName));
            // this.hardwaresList = this.hardwaresListByPackage.filter(f =>
            //     uniqueAddonsList.has(f.hardwareFor)
            // )
            this.calculate();
        }
    }
    goToPricing() {
        window.open('https://lincsell.com/pricing/', '_blank');
    }
    OpenContactForm() {
        document.location = 'https://lincsell.com/#contact_us';
    }

    getHardwareList() {
        try {
            this._signup.getHardwarePlanListv2().subscribe((res) => {
                if (res.success) {
                    // In your component.ts, e.g. ngOnInit or wherever you load res.data:

                    this.hardwaresList = res.data[0].items.map(v => ({
                        ...v,
                        selectedQuantity: 0,
                        hardwareFor:"POS Pro",
                        isLease: v.title === 'Pax E800' || v.title === 'Pax E700',
                        leasePrice: v.title === 'Pax E800' ? 90 : v.title === 'Pax E700' ? 80 : 0,
                        selectedPricingOption: 'OneTimePrice',   // default to one-time for these
                    }));

                    // Append Ingenico LANE 3000 with lease allowed but no default selection:
                    this.hardwaresList = [
                        ...this.hardwaresList,
                        ...res.data[1].items
                        .filter(f => f.title === 'Ingenico LANE 3000')
                        .map(v => ({
                            ...v,
                            hardwareFor:"POS Pro",
                            selectedQuantity: 0,
                            isLease: false,
                            leasePrice: 0,
                            selectedPricingOption: 'NotSelected',  // require user to pick
                        }))
                    ];

                    // Append non-leaseables with no default:
                    this.hardwaresList = [
                        ...this.hardwaresList,
                        ...res.data[2].items
                        .filter(f =>
                            ['Cash Drawer','Barcode Scanner','Receipt Printer'].includes(f.title)
                        )
                        .map(v => ({
                            ...v,
                            selectedQuantity: 0,
                            hardwareFor:"POS Pro",
                            isLease: false,
                            leasePrice: 0,
                            selectedPricingOption: 'NotSelected',
                        }))
                    ];
                    this.hardwaresList.map(f=> f.withTaxPrice = 0)
                    this.hardwaresListByPackage =this.hardwaresList
                    this.hardwaresList = this.hardwaresList.filter(
                        (h) => h.title !== ''
                    );


                    if (this._signup.selectedHardware.length > 0) {
                        setTimeout(() => {
                            this.hardwaresList.forEach((hardware) => {
                                const selectedItem =
                                    this._signup.selectedHardware.find(
                                        (selected) =>
                                            selected.id === hardware.id
                                    );
                                hardware.selectedQuantity = selectedItem
                                    ? selectedItem.selectedQuantity
                                    : 0;
                            });

                            // const uniqueAddonsList = new Set(  plan.addons =  this._signup.selectedPlans[0]?.addons.filter(f=> !f.defaultAddedInSubscription).map(item => item.planName));
                            // this.hardwaresList = this.hardwaresListByPackage.filter(f =>
                            //     uniqueAddonsList.has(f.hardwareFor)
                            // )
                            this.calculate();
                        }, 400);
                    }
                    if(sessionStorage.getItem('selected-hardwares')){
                        this._signup.selectedHardware = JSON.parse(sessionStorage.getItem('selected-hardwares'))
                        this.hardwaresList.forEach((hardware) => {
                            const selectedItem =
                                this._signup.selectedHardware.find(
                                    (selected) =>
                                        selected.id === hardware.id
                                );
                            hardware.selectedPricingOption = selectedItem
                                ? selectedItem.selectedPricingOption
                                : "OneTimePrice";
                        });
                    }
                    // this.showHardwares = this.hardwaresList.some(f => f.selected );
                    // const uniqueAddonsList = new Set(  plan.addons =  this._signup.selectedPlans[0]?.addons.filter(f=> !f.defaultAddedInSubscription).map(item => item.planName));
                    // this.hardwaresList = this.hardwaresListByPackage.filter(f =>
                    //     uniqueAddonsList.has(f.hardwareFor)
                    // )
                    // this.isShowRegistersAndLocations = false;
                    // this.showHardwares = false;
                    // if(this._signup.selectedPlans[0]?.id > 2){
                    //     this.isShowRegistersAndLocations = true;
                    //     this.showHardwares = true;
                    // }
                        //
                   // this.isShowRegistersAndLocations = true;
                }
            });
        } catch (error) {
            console.log(error);
        }
    }

    calculateTotalRegisterAndLocatons(value = false) {
        try {
            if (
                this.isRegisterAndLocationAllowed() === true &&
                this._signup.selectedLocationsAndRegistersList &&
                this._signup.selectedLocationsAndRegistersList.length > 0
            ) {
                this.totalRegistersPrice =
                    this._signup.selectedLocationsAndRegistersList
                        .filter((pkg) => pkg.id === 1 && pkg.quantity > 1)
                        .reduce(
                            (total, pkg) =>
                                total +
                                (pkg.quantity - this._signup.selectedPlans[0].defaultRegister) *
                                    (this._signup.selectedPlanInterval === 'Yearly'
                                        ? pkg.price * 12
                                        : pkg.price),
                            0
                        );

                this.totalLocationsPrice =
                    this._signup.selectedLocationsAndRegistersList
                        .filter((pkg) => pkg.id === 2 && pkg.quantity > 1)
                        .reduce(
                            (total, pkg) =>
                                total +
                                (pkg.quantity - this._signup.selectedPlans[0].defaultLocation) *
                                    (this._signup.selectedPlanInterval === 'Yearly'
                                        ? pkg.price * 12
                                        : pkg.price),
                            0
                        );
            } else {
                // let selPlans:any = sessionStorage.getItem('checkout-signup-subscription')
                // if(selPlans != undefined && selPlans != null){
                //     this._signup.selectedLocationsAndRegistersList = JSON.parse(sessionStorage.getItem('selected-additional-loc-reg'))
                //     this._signup.selectedHardware = JSON.parse(sessionStorage.getItem('selected-hardwares'))
                //     return false;
                // }

                if(this.plans.length > 0){
                    let defaultLocation = 1;
                    let defaultRegister = 1;
                    let currentPlan = this.plans.find(t => t.selected );
                    if(this._signup.selectedPlans[0]?.id != undefined){
                        defaultLocation = currentPlan.defaultLocation;
                        defaultRegister = currentPlan.defaultRegister;
                    }

                    if(this.registersAndLocationsList.length > 0){
                        this.registersAndLocationsList = this.registersAndLocationsList.map(
                            (v) => {
                                return { ...v,
                                    quantity: (currentPlan.id != 4 ? defaultLocation : (v.name == "Registers"?currentPlan.defaultRegister : currentPlan.defaultLocation )) ,
                                    defaultRegister : (currentPlan.id != 4 ? defaultLocation : (v.name == "Registers"?currentPlan.defaultRegister : currentPlan.defaultLocation )),
                                    defaultLocation : (currentPlan.id != 4 ? defaultLocation : (v.name == "Locations"?currentPlan.defaultLocation : currentPlan.defaultLocation ))
                                };
                            }
                        );
                    }

                    this.totalRegistersPrice = 0;
                    this.totalLocationsPrice = 0;
                }
            }
        } catch (error) {

        }
    }

    calculateTotalHardware(value = false) {
        try {
            if (
                this.isRegisterAndLocationAllowed() === true &&
                this.isShowHardware === false &&
                this._signup.selectedHardware.length > 0
            ) {
                this.totalHaredwarePrice = this._signup.selectedHardware
                    .filter((pkg) => pkg.selectedQuantity > 0)
                    .reduce(
                        (total, pkg) => total + pkg.selectedQuantity * (pkg.selectedPricingOption == 'LeasePrice' ? pkg.leasePrice : pkg.price),
                        0
                    );
            } else {
                this.hardwaresList = this.hardwaresList.map((v) => {
                    return { ...v, selectedQuantity: 0 };
                });
                this._signup.selectedHardware = [];
                this.totalHaredwarePrice = 0;
            }
        } catch (error) {

        }
    }

    selectPlan(selectedPlan: any) {
        if (selectedPlan.id === 5) {
            this.plans.forEach((plan) => (plan.selected = plan.id === 5));
        } else {
            selectedPlan.selected = !selectedPlan.selected;
           selectedPlan.addons.forEach((plan) => (plan.selected = false));

           selectedPlan.addons = selectedPlan.addons.filter(f=> !f.defaultAddedInSubscription)
            this.plans
                .filter((t) => t.id !== selectedPlan.id).forEach((plan) => (plan.selected = false));
        }
        this.isShowRegistersAndLocations = false
        this.showHardwares = false



        // && selectedPlan.addons.filter(f=> f.planName == 'POS Pro' && f.selected).length > 0
        // if (selectedPlan.addons.filter(f => f.defaultAddedInSubscription  ).length > 0) {
        //     this.isShowRegistersAndLocations = selectedPlan.selected;
        //     this.showHardwares = this.isShowRegistersAndLocations
        // }
        // else this.isShowRegistersAndLocations = false;

        // if(selectedPlan.addons.length > 0){
        //     this.isShowRegistersAndLocations = selectedPlan.addons.filter(f =>
        //         ['POS Lite','POS Pro'].includes(f.title)
        //     ).length > 0 ? true : false;
        //     this.showHardwares = this.isShowRegistersAndLocations
        // }
        // && selectedPlan.addons.filter(f=> f.planName == 'POS Pro' && f.selected).length > 0
        // if (selectedPlan.addons.filter(f => f.defaultAddedInSubscription  ).length > 0) {
        //     this.isShowRegistersAndLocations = selectedPlan.selected;
        // }

        setTimeout(() => {
            if(this.isShowRegistersAndLocations){
                let defaultLocation = 1;
                let defaultRegister = 1;
                let currentPlan = this.plans.find(t => t.selected == true);

                if(this._signup.selectedPlans[0]?.id != undefined && this._signup.selectedPlans[0]?.id == 4){
                    defaultLocation = currentPlan.defaultLocation;
                    defaultRegister = currentPlan.defaultRegister;
                }

                this.registersAndLocationsList = this.registersAndLocationsList.map(
                    (v) => {
                        return { ...v,
                            quantity:   (currentPlan.id != 4 ? defaultLocation : (v.name == "Registers"?currentPlan.defaultRegister : currentPlan.defaultLocation )) ,
                            defaultRegister : (currentPlan.id != 4 ? defaultLocation : (v.name == "Registers"?currentPlan.defaultRegister : currentPlan.defaultLocation )),
                            defaultLocation : (currentPlan.id != 4 ? defaultLocation : (v.name == "Locations"?currentPlan.defaultLocation : currentPlan.defaultLocation ))
                        };
                    }
                );
                this._signup.selectedLocationsAndRegistersList = [];
                this.calculate();
            }
        }, 200);

      //  this.showHardwares = this.isShowRegistersAndLocations
        // const uniqueAddonsList = new Set(selectedPlan.addons.map(item => item.planName));
        // this.hardwaresList = this.hardwaresListByPackage.filter(f =>
        //     uniqueAddonsList.has(f.hardwareFor)
        // )
        if(selectedPlan.id >2){
            this.isShowRegistersAndLocations = true
            this.showHardwares = true
        }
        this.calculate();

        const selectedPlanFromLincSell = sessionStorage.getItem('selected_plan_id');
        if(selectedPlanFromLincSell){

            sessionStorage.removeItem('selected_plan_id')
        }

    }

    ShowRegistersAndLocations() {

        if (this._signup.selectedPlans?.length > 0)
            this.isShowRegistersAndLocations =
                this._signup.selectedPlans.filter((item) => item.id > 2)
                    .length > 0 ||
                this.getselectedAddons?.filter((plan) => plan.id  > 2).length >
                    0;
        else this.isShowRegistersAndLocations = false;
    }

    selectAddon(selectedPlan: any) {

        // if (selectedPlan.id === 5) {
        //     this.plans.forEach((plan) => (plan.selected = plan.id === 5));
        // }
        // else {
           selectedPlan.selected = !selectedPlan.selected;
          this.isShowRegistersAndLocations = false
            if ( this._signup.selectedPlans[0]?.id >2 )
                this.isShowRegistersAndLocations = true;
        //}

        sessionStorage.setItem("checkout-signup-subscription", JSON.stringify(this._signup.selectedPlans));
        this.calculate();
    }

    isRegisterAndLocationAllowed(): boolean {
        // this.isShowRegistersAndLocations=this._signup.selectedPlans?.find(t=>t.planId===3).length>0
        return this.isShowRegistersAndLocations;
    }

    selectOption(option: string) {
        this._signup.selectedPlanInterval = option;
        if (this._signup.selectedPlanInterval === 'Monthly') {
            this.plans.forEach((plan) => (plan.isMonthly = true));
        } else {
            this.plans.forEach((plan) => (plan.isMonthly = false));
        }
        sessionStorage.setItem(
            'interval',
            JSON.stringify(this._signup.selectedPlanInterval)
        );
        this.calculate();
    }

    addRegistersAndLocations(value) {

        const selectedPackage = this.registersAndLocationsList.find(
            (pkg) => pkg.id === value.id
        );
        if (selectedPackage) {
            selectedPackage.quantity++;
        }
        this._signup.selectedLocationsAndRegistersList =
        this.registersAndLocationsList.filter((v) => v.quantity > 1);
        sessionStorage.setItem(
            'registersAndLocationsList',
            JSON.stringify(this.registersAndLocationsList)
        );
        sessionStorage.setItem(
            'selected-additional-loc-reg',
            JSON.stringify(this._signup.selectedLocationsAndRegistersList)
        );
        this.calculate();
    }

    subRegistersAndLocations(value) {
        const selectedPackage = this.registersAndLocationsList.find(
            (pkg) => pkg.id === value.id
        );
        if (selectedPackage && selectedPackage.quantity > 0) {
            selectedPackage.quantity--;
        }
        this._signup.selectedLocationsAndRegistersList =
            this.registersAndLocationsList.filter((v) => v.quantity > 1);
            sessionStorage.setItem(
                'registersAndLocationsList',
                JSON.stringify(this.registersAndLocationsList)
            );
            sessionStorage.setItem(
                'selected-additional-loc-reg',
                JSON.stringify(this._signup.selectedLocationsAndRegistersList)
            );
        this.calculate();
    }

    addHardware(value: any) {
        const selectedPackage = this.hardwaresList.find(
            (pkg) => pkg.id === value.id
        );
        if (selectedPackage) {
            selectedPackage.selectedQuantity++;
        }
        this._signup.selectedHardware = this.hardwaresList.filter(
            (pkg) => pkg.selectedQuantity > 0
        );
        sessionStorage.setItem(
            'selected-hardwares',
            JSON.stringify(this._signup.selectedHardware)
        );
        this.calculate();
    }

    subHardware(value: any) {
        const selectedPackage = this.hardwaresList.find(
            (pkg) => pkg.id === value.id
        );
        if (selectedPackage && selectedPackage.selectedQuantity > 0) {
            selectedPackage.selectedQuantity--;
        }
        this._signup.selectedHardware = this.hardwaresList.filter(
            (pkg) => pkg.selectedQuantity > 0
        );
        sessionStorage.setItem(
            'hardware-list',
            JSON.stringify(this.hardwaresList)
        );
        sessionStorage.setItem(
            'selected-hardwares',
            JSON.stringify(this._signup.selectedHardware)
        );
        this.calculate();
    }

    calculate() {

        this._signup.selectedPlans = this.plans.filter((plan) => plan.selected);

        this.isFreeSubscription = this._signup.selectedPlans.find(f=> f.selected)?.freeSubscription == true ? true : false;
        this._signup.selectedPlans.map(f=> f.withTaxPrice = 0)
        let totalPriceWithTax = 0
        this.totalPlanCost = 0;

        if(!this.isFreeSubscription){
            this.totalPlanCost = this._signup.selectedPlans.reduce(
                (total, plan) =>
                    total +
                    (this._signup.selectedPlanInterval === 'Yearly'
                        ? plan.yearlyPrice * 12
                        : plan.monthlyPrice),
                0
            );


            if(this._signup.selectedPlans[0] != undefined){
                 this._signup.selectedPlans[0].withTaxPrice = 0;
                if(this.stateValue  == 'TX'){

                    this._signup.selectedPlans[0].withTaxPrice = this._signup.selectedPlanInterval === 'Yearly'
                    ? this._signup.selectedPlans[0].yearlyPrice * 12 : this._signup.selectedPlans[0].monthlyPrice

                    this._signup.selectedPlans[0].withTaxPrice = parseFloat(this._signup.selectedPlans[0].withTaxPrice.toFixed(2));
                    this._signup.selectedPlans[0].withTaxPrice = this._signup.selectedPlans[0].withTaxPrice * 0.0825;
                    this._signup.selectedPlans[0].withTaxPrice = parseFloat(this._signup.selectedPlans[0].withTaxPrice.toFixed(2));
                    totalPriceWithTax += this._signup.selectedPlans[0].withTaxPrice;
                }
            }

        }


        let addonsCost =    this._signup.selectedPlans[0]?.addons.filter(f=> !f.defaultAddedInSubscription)
            ?.filter((t) => t.selected)
            ?.reduce(
                (total, plan) =>
                    total +
                    (this._signup.selectedPlanInterval === 'Yearly'
                        ? plan.yearlyPrice * 12
                        : plan.monthlyPrice),
                0
            );
        if(isNaN(addonsCost))
            addonsCost = 0;
        this.discount = 0;
        if(!this.isFreeSubscription){
            // this.discount = this._signup.selectedPlans.reduce(
            //     (total, plan) =>
            //         total +
            //         (this._signup.selectedPlanInterval === 'Yearly'
            //             ? plan.yearlyPrice * 3
            //             : plan.monthlyPrice - 1),
            //     0
            // );
        }


        this.calculateTotalRegisterAndLocatons();
        this.calculateTotalHardware();

        // }

        //this.subTotal = this.totalPlanCost

        const subscriptionPlanPriceOnly = this.totalPlanCost;
        let discountPrice = subscriptionPlanPriceOnly - this.discount; ;
        discountPrice = parseFloat(discountPrice.toFixed(2));
        this.discountedSubscriptionPlanPrice = discountPrice;




        let cur = this;
        console.log("Subscription", totalPriceWithTax)
        if(this._signup.selectedPlans[0] != undefined){
            if(this._signup.selectedPlans.length > 0){
                if(this._signup.selectedPlans.filter(f=> f.selected)[0].addons.length > 0){
                    this._signup.selectedPlans.filter(f=> f.selected)[0].addons.filter(f=> f.selected).map((plan) => {
                        plan.withTaxPrice = 0;

                        if(this.stateValue  == 'TX'){
                            plan.withTaxPrice = this._signup.selectedPlanInterval === 'Yearly'
                            ? plan.yearlyPrice * 12 : plan.monthlyPrice

                            plan.withTaxPrice = parseFloat(plan.withTaxPrice.toFixed(2));
                            plan.withTaxPrice = plan.withTaxPrice * 0.0825;
                            plan.withTaxPrice = parseFloat(plan.withTaxPrice.toFixed(2));

                            totalPriceWithTax += plan.withTaxPrice;
                        }
                    });
                    console.log("Addons", totalPriceWithTax)
                }
                const selectedPlan = this._signup.selectedPlans.filter(f=> f.selected)[0];
                if(this._signup.selectedLocationsAndRegistersList.length > 0){
                    this._signup.selectedLocationsAndRegistersList.map((plan,i) => {
                        if(i == 0){
                                this.totalRegistersPrice = this._signup.selectedPlanInterval === 'Yearly'
                            ? (12 * ((plan.quantity - (i == 0 ? selectedPlan.defaultRegister : selectedPlan.defaultLocation)) * plan.price)) :
                            (1 * ((plan.quantity - (i == 0 ? selectedPlan.defaultRegister : selectedPlan.defaultLocation)) * plan.price))
;
                            }
                            else{
                                this.totalLocationsPrice = this._signup.selectedPlanInterval === 'Yearly'
                            ? (12 * ((plan.quantity - (i == 0 ? selectedPlan.defaultRegister : selectedPlan.defaultLocation)) * plan.price)) :
                            (1 * ((plan.quantity - (i == 0 ? selectedPlan.defaultRegister : selectedPlan.defaultLocation)) * plan.price))
;
                            }

                        plan.withTaxPrice = 0;
                        if(this.stateValue  == 'TX'){
                            plan.withTaxPrice = this._signup.selectedPlanInterval === 'Yearly'
                            ? (12 * ((plan.quantity - (i == 0 ? selectedPlan.defaultRegister : selectedPlan.defaultLocation)) * plan.price)) :
                            (1 * ((plan.quantity - (i == 0 ? selectedPlan.defaultRegister : selectedPlan.defaultLocation)) * plan.price))


                            plan.withTaxPrice = parseFloat(plan.withTaxPrice.toFixed(2));
                            plan.withTaxPrice = plan.withTaxPrice * 0.0825;
                            plan.withTaxPrice = parseFloat(plan.withTaxPrice.toFixed(2));
                            totalPriceWithTax += plan.withTaxPrice;


                        }
                    });
                }

                totalPriceWithTax =  parseFloat(totalPriceWithTax.toFixed(2));
                console.log("Location", totalPriceWithTax)
                if(this._signup.selectedHardware.length > 0){
                    this._signup.selectedHardware.map((plan) => {
                        plan.withTaxPrice = 0;
                        if(this.stateValue  == 'TX'){
                            plan.withTaxPrice =  ( (plan.selectedQuantity * plan.price))
                            plan.withTaxPrice = parseFloat(plan.withTaxPrice.toFixed(2));
                            plan.withTaxPrice = plan.withTaxPrice * 0.0825;
                            plan.withTaxPrice = parseFloat(plan.withTaxPrice.toFixed(2));
                            totalPriceWithTax += plan.withTaxPrice;
                        }
                    });
                     totalPriceWithTax =  parseFloat(totalPriceWithTax.toFixed(2));
                    console.log("Hardware", totalPriceWithTax)
                }

            }
        }

           this.totalLocationsPrice = parseFloat(this.totalLocationsPrice.toFixed(2));
        this.totalRegistersPrice = parseFloat(this.totalRegistersPrice.toFixed(2));
        this.totalHaredwarePrice = parseFloat(this.totalHaredwarePrice.toFixed(2));

        const subtotalWithoutDiscount = subscriptionPlanPriceOnly + addonsCost + (this.totalLocationsPrice +this.totalRegistersPrice +this.totalHaredwarePrice);
        this.subTotal = parseFloat(subtotalWithoutDiscount.toFixed(2));

        const subtotalWithDiscount = discountPrice + addonsCost + (this.totalLocationsPrice +this.totalRegistersPrice +this.totalHaredwarePrice);

        this.subTotalWithoutDiscount = subtotalWithoutDiscount;
        this.subTotalWithDiscount = subtotalWithDiscount;

        if (isNaN(this.subTotal)) {
            this.subTotal = 0.0;
        }
        if (isNaN(this.discount)) {
            this.discount = 0.0;
        }

        totalPriceWithTax= parseFloat(totalPriceWithTax.toFixed(2));
        if (/^\d{5}$/.test(this.addressForm.get('zipCode').value)) {
            this.taxAmount = totalPriceWithTax; //this.calcTax(totalPriceWithTax);
            this.taxAmount = parseFloat(this.taxAmount.toFixed(2));
        }

        if (isNaN(this.taxAmount)) {
            this.taxAmount = 0.0;
        }

        this.grandTotal = this.taxAmount + subtotalWithDiscount  ;

    }

    inputVlaue() {
        this.inValidCode = false;
    }
    apply() {
        this._spinner.show();

        setTimeout(() => {
            this.isLoading = false;
            //    if(this.discountValue === "flat10%"){
            //     this.applyDiscount = this.discountValue
            //     let discountValue = this.discount
            //      let  disVal = discountValue.toString().split('.')
            //      let first = disVal[0];
            //      let second = disVal[1].substring(0, 2);
            //      let discountOnly = Number(first+'.'+second);
            //      this.discount =  discountOnly

            //      this.inValidCode = false
            //     this.discountValue = ""
            //     this._spinner.hide()
            // } else{
            this.inValidCode = true;
            this.applyDiscount = null;
            //  }
            this._abd.hideSpinner();
        }, 2000);
    }

    calcTaxValue() {
        try {
            let ret = 0.0;

            ret = 0;
            this.taxRate = 0;
            if (this.selectedState.abbreviation == 'TX') {
                ret = 8.25;
                this.taxRate = 8.25;
            }
            return ret == undefined || ret == null ? ret : ret;
        } catch (error) {}
    }

    calcTax(val: any) {
        try {
            if (val >= 0) {
                let taxrate = this.calcTaxValue();
                this.taxRate = taxrate;
                if (taxrate == undefined) {
                    taxrate = 0;
                }
                taxrate = taxrate /= 100;

                let ret = val * taxrate;

                return parseFloat(ret.toFixed(2));
            }
            return 0;
        } catch (error) {}
    }
    goBack() {
        this._router.navigate(['signup/personal-info']);
    }
    getNextDate(option: any): Date {
        const currentDate = new Date();
        if (option === 'Monthly') {
            currentDate.setMonth(currentDate.getMonth() + 1);
        } else if (option === 'Yearly') {
            currentDate.setFullYear(currentDate.getFullYear() + 1);
        } else {
            throw new Error("Invalid option. Use 'Monthly' or 'Yearly'.");
        }
        return currentDate;
    }
    onSelect(item: any) {
        this.isShowHardware = item.checked;
        this.calculate();
    }
    onShowShippingAddress(value: any) {
        this.isBusinessAddressisShippingAddress = value.checked;
    }

    onStateChange(event: { originalEvent: Event; value: string }) {
        this.calculate();
    }

    zipcodeInputEvent(value: string) {

        const zip = (value || '').trim();

        if (!zip) {
          this.taxAmount = 0;
          this.calculate();
          return;
        }

        if (!/^\d{5}$/.test(zip)) {
            // invalid format: you could show an error message here
            return;
        }
        this.showCityWait = true;
        this._abd.getCityAndStateInfo(zip).pipe(
            // 4. Handle HTTP errors gracefully
            catchError(() => {
              // on error, treat as invalid ZIP
              this.addressForm.patchValue({ city: '' });
              this.addressForm.get('city').setErrors({ invalid: true });

              this.selectedState = this.usaStates[0];
              return of(null);
            }),
            // 5. Always hide spinner when done
            finalize(() => this.showCityWait = false)
          )
          .subscribe(res => {
            // 6. If lookup succeeded, patch city & state
            if (res?.success && res.data.city != undefined) {
                this.stateValue = res.data.state;
              this.selectedState =
                this.usaStates.find(s => s.abbreviation === res.data.state)
                ?? this.usaStates[0];
                this.addressForm.get('city').setErrors({ invalid: false })
              this.addressForm.patchValue({ city: res.data.city });
              ;
            //  this.addressForm.get('zipCode').setErrors({ invalid: false });
            }
            else{
                this.addressForm.patchValue({ city: '' });
                this.addressForm.get('city').setErrors({ invalid: true });
            }
            // 7. Recalculate totals & tax
            this.calculate();
          });
        // this._abd.getCityAndStateInfo(value).subscribe((res: any) => {
        //     this.showCityWait = false;
        //     if (res.success && res.data.city != undefined) {
        //         const st = this.usaStates.filter(
        //             (s) => s.abbreviation == res.data.state
        //         );
        //         this.selectedState = st[0];
        //         this.addressForm.patchValue({ city: res.data.city });
        //     } else {
        //         this.addressForm.patchValue({ city: 'Invalid zip code' });
        //         this.selectedState = this.usaStates[0];
        //     }

        //     console.log(this.taxAmount)
        //     this.calculate();
        // });
    }
    goTo() {
        window.location.href = 'https://lincsell.com/';
    }
    zipcodeInputSEvent(value: string) {
        if (!value || value.length !== 5) return;
        this.showSCityWait = true;
        this._abd.getCityAndStateInfo(value).subscribe((res: any) => {
            this.showSCityWait = false;
            if (res.success && res.data.city != undefined) {
                const st = this.usaStates.filter(
                    (s) => s.abbreviation == res.data.state
                );
                this.selectedSState = st[0];
                this.shippingForm.patchValue({ city: res.data.city });
            } else {
                this.shippingForm.patchValue({ city: '' });
                this.selectedSState = this.usaStates[0];
            }
            this.calculate();
        });
    }

    initForm() {
        this.addressForm = this._fb.group({
            address: ['', Validators.required],
            address2: [''],
            zipCode: ['', Validators.required],
            city: ['', Validators.required],
        });

        let adres = JSON.parse(sessionStorage.getItem('address'));
        if (adres !== null) {
            this.addressForm.get('address').setValue(adres.address);
            this.addressForm.get('address2').setValue(adres.address2);
            this.addressForm.get('zipCode').setValue(adres.zipCode);
            this.addressForm.get('city').setValue(adres.city);

            this.zipcodeInputEvent(adres.zipCode);
        }
        // Previously only written to sessionStorage right before submit — a reload before that
        // point lost whatever the merchant had typed even though initForm() above already knows
        // how to restore it. Persist on every keystroke instead so a reload always has the latest.
        this.addressForm.valueChanges.subscribe((value) => {
            sessionStorage.setItem('address', JSON.stringify(value));
        });

        this.shippingForm = this._fb.group({
            address: ['', Validators.required],
            address2: [''],
            zipCode: ['', Validators.required],
            city: ['', Validators.required],
        });
        let ship = JSON.parse(sessionStorage.getItem('shipping'));
        if (ship !== null) {
            this.isBusinessAddressisShippingAddress = false;

            this.shippingForm.get('address').setValue(ship.address);
            this.shippingForm.get('address2').setValue(ship.address2);
            this.shippingForm.get('zipCode').setValue(ship.zipCode);
            this.shippingForm.get('city').setValue(ship.city);
            this.zipcodeInputSEvent(ship.zipCode);
        }
        this.shippingForm.valueChanges.subscribe((value) => {
            if (!this.isBusinessAddressisShippingAddress) {
                sessionStorage.setItem('shipping', JSON.stringify(value));
            }
        });
        let hardware = sessionStorage.getItem('allowHardware');
        if (hardware !== null && hardware === 'No') {
            this.isShowHardware = false;
        }
    }

    showHardwareDetail(hardware) {
        this.selectHardware = hardware;
        this.isShowHardwareDetail = true;
    }

    saveFn() {
        try {
            let websiteDomain: string = '';
            websiteDomain = window.location.origin + '/'; // this._globals.whiteLabel.domain
            var n = websiteDomain.lastIndexOf('/');
            var result = websiteDomain.substring(n + 1);

            if (result == '') {
                websiteDomain = websiteDomain.substring(
                    0,
                    websiteDomain.length - 1
                );
            }

            this._signup.checkoutPageInfo.totalAmount = this.grandTotal;
            let hardwarePackagesId = [];
            let hardwarePkg = [];
            let SubscribedFeatures = [];

            let taxRate = 0;
            if (this.taxRate > 0) {
                this.taxRate = 8.25;
                taxRate = this.taxRate /= 100;
            }

            if (this._signup.selectedPlans.length < 1) {
                return this._connMessageService.showToastMessage(
                    'Select plan to proceed',
                    'error'
                );
            }

            if (!this.addressForm.valid) {
                Object.keys(this.addressForm.controls).forEach((field) => {
                    const control = this.addressForm.get(field);
                    control?.markAsTouched();
                    control?.updateValueAndValidity();
                });
                return this._connMessageService.showToastMessage(
                    'Add Business address',
                    'error'
                );
            }
            if (!this.isBusinessAddressisShippingAddress) {
                if (!this.shippingForm.valid) {
                    Object.keys(this.shippingForm.controls).forEach((field) => {
                        const control = this.shippingForm.get(field);
                        control?.markAsTouched();
                        control?.updateValueAndValidity();
                    });
                    return this._connMessageService.showToastMessage(
                        'Add Shipping address',
                        'error'
                    );
                }
            }

            let subscriptionPlanPkg = [];
            let plans = [];
            let locAndRegList = [];
            let hardwareList = [];
            let addons = [];
             let noOfRegisters = 1;
            let noOfLocations = 1;
            if (
                this._signup.selectedLocationsAndRegistersList &&
                this._signup.selectedLocationsAndRegistersList.length > 0
            ) {

                    this._signup.selectedLocationsAndRegistersList.map((v, i) => {

                            // this._signup.selectedPlanInterval === 'Yearly'
                            //     ? v.price * 12 * ((i == 0 ? v.defaultRegister: v.) - 1)
                            //     : v.price * (v.quantity - 1);

                           let subtotalCost = this._signup.selectedPlanInterval === "Yearly"
                                                            ? ((12 * ((v.quantity - (i == 0 ? this._signup.selectedPlans[0].defaultRegister : this._signup.selectedPlans[0].defaultLocation)) * v.price)))
                                                            : ((1 * ((v.quantity - (i == 0 ? this._signup.selectedPlans[0].defaultRegister : this._signup.selectedPlans[0].defaultLocation)) * v.price)))

                        let qty = (v.quantity - (i == 0 ? this._signup.selectedPlans[0].defaultRegister : this._signup.selectedPlans[0].defaultLocation))
                        if(v.name == "Registers"){
                            noOfRegisters = qty;
                        }
                        else{
                            noOfLocations = qty;
                        }
                        let taxAmount = this.calcTax(subtotalCost);
                        if(subtotalCost > 0){
                            locAndRegList.push( {
                                name: v.name,
                                reOccurring: true,
                                oneTimePrice: 0,
                                packageId: 'prod_RvFVoScRNnwr3x',
                                qty: qty ,
                                pricePerPackage: v.price.toFixed(2),
                                subTotalCost: subtotalCost.toFixed(2),
                                packageType: 0,
                                discountValue: 0,
                                taxValue: this.taxRate,
                                discountAmount: 0,
                                taxAmount: taxAmount.toFixed(2),
                                isDiscountPercent: false,
                                isTaxPercent: false,
                                totalPrice: (subtotalCost ).toFixed(2),
                            });
                        }

                    });
            }


            plans = this._signup.selectedPlans.map((v) => {
                let pricePerPackage =
                    this._signup.selectedPlanInterval === 'Yearly'
                        ? v?.yearlyPrice
                        : v.monthlyPrice;
                let price =
                    this._signup.selectedPlanInterval === 'Yearly'
                        ? v?.yearlyPrice * 12
                        : v.monthlyPrice;
                let taxAmount = this.calcTax(this.discountedSubscriptionPlanPrice);
                addons = [];
                if (v.id === 3 || v.id === 4) {
                    addons = locAndRegList;
                } else {
                    addons = [];
                }
                return {
                    name: v.planName,
                    additionalData: {},
                    addons: addons,
                    reOccurring: true,
                    oneTimePrice: 0,
                    packageId: v.id.toString(),
                    qty: 1,
                    pricePerPackage: pricePerPackage.toFixed(2),
                    subTotalCost: this.totalPlanCost.toFixed(2),
                    packageType: 0,
                    discountValue: 0,
                    taxValue: this.taxRate.toFixed(2),
                    discountAmount: this.discount.toFixed(2),
                    taxAmount: taxAmount.toFixed(2),
                    isDiscountPercent: false,
                    isTaxPercent: true,
                    totalPrice: this.discountedSubscriptionPlanPrice,
                    isSubscription: true,
                };
            });

            subscriptionPlanPkg = plans;

            if (this._signup.selectedHardware.length > 0) {
                hardwareList = this._signup.selectedHardware.map((v) => {
                    let subtotalCost = v.price * v?.selectedQuantity;
                    let taxAmount = this.calcTax(subtotalCost);
                    return {
                        name: v.title,
                        addons: [],
                        additionalData: {},
                        reOccurring: false,
                        oneTimePrice: 0,
                        packageId: 'prod_RvFXtr0rpUrhDf',
                        qty: v.selectedQuantity,
                        pricePerPackage: v.price.toFixed(2),
                        subTotalCost: subtotalCost.toFixed(2),
                        packageType: 0,
                        discountValue: 0,
                        taxValue: this.taxRate,
                        discountAmount: 0,
                        taxAmount: taxAmount.toFixed(2).toString(),
                        isDiscountPercent: false,
                        isTaxPercent: false,
                        totalPrice: (subtotalCost ).toFixed(2),
                        isLease: v.isLease,
                        leasePrice: v.leasePrice,
                        selectedPricingOption: v.selectedPricingOption,
                    };
                });
            }


            let TransactionDetails = {
                accountType: '',
                accountNumber: '',
                transId: '',
                responseCode: '1',
                paymentMethod: 'Stripe',
                authorization: '',
                merchantName: 'Connect-360',
                billTo: {
                    phoneNumber: '',
                    firstName: '',
                    lastName: '',
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: 'US',
                },
                totalAmount: this.grandTotal,
                dateTime: new Date(),
            };

             if(!this.isBusinessAddressisShippingAddress){
              TransactionDetails.billTo ={
                  "phoneNumber": "",
                  "firstName": "",
                  "lastName": "",
                  "address": this.sf.address.value,
                  "city": this.sf.city.value,
                  "state": this.selectedSState.abbreviation,
                  "zip": this.sf.zipCode.value,
                  "country": "US"
              }
             }
             else{
                TransactionDetails.billTo ={
                    "phoneNumber": "",
                    "firstName": "",
                    "lastName": "",
                    "address": this.bf.address.value,
                    "city": this.bf.city.value,
                    "state": this.selectedState.abbreviation,
                    "zip": this.bf.zipCode.value,
                    "country": "US"
                }
             }

            this._signup.selectedPlans = this._signup.selectedPlans;
            this._signup.additionalEquipment =
                this._signup.selectedLocationsAndRegistersList;
            sessionStorage.setItem(
                'selected-plans',
                JSON.stringify(this._signup.selectedPlans)
            );
            sessionStorage.setItem(
                'selected-hardwares',
                JSON.stringify(this._signup.selectedHardware)
            );
            sessionStorage.setItem(
                'selected-additional-loc-reg',
                JSON.stringify(this._signup.additionalEquipment)
            );
            sessionStorage.setItem(
                'registersAndLocationsList',
                JSON.stringify(this.registersAndLocationsList)
            );
            sessionStorage.setItem(
                'grandTotal',
                JSON.stringify(this.grandTotal)
            );
            sessionStorage.setItem(
                'interval',
                JSON.stringify(this._signup.selectedPlanInterval)
            );
            sessionStorage.setItem(
                'address',
                JSON.stringify(this.addressForm.value)
            );
            if (!this.isShowHardware) {
                sessionStorage.setItem('allowHardware', 'No');
            } else {
                sessionStorage.removeItem('allowHardware');
            }
            if (this.isBusinessAddressisShippingAddress === false) {
                sessionStorage.setItem(
                    'shipping',
                    JSON.stringify(this.shippingForm.value)
                );
            } else {
                sessionStorage.removeItem('shipping');
            }

            let personalInfo = JSON.parse(
                sessionStorage.getItem('personal-Info')
            );

            let customerEmail = null;
            if (personalInfo !== null) {
                customerEmail = personalInfo.email;
            } else {
                customerEmail = this._globals.userInfo?.email;
            }
            let CCCustomerProfile = {
                TransactionId: '',
                CustomerEmail: customerEmail,
                StartDate: '2022-10-18',
                IntervalLength:
                    this._signup.selectedPlanInterval === 'Monthly' ? 1 : 12,
                Amount: '0.00',
                TrialAmount: 0,
                SubTotal: 0,
                Tax: 0,
            };

            let couponObj: any;
            if (this._signup.couponCodeData?.couponCodes !== undefined) {
                couponObj = {
                    discountValueType:
                        this._signup.couponCodeData?.discountValueType,
                    id: this._signup.couponCodeData?.id,
                    couponCodes: this._signup.couponCodeData?.couponCodes,
                    discountName: this._signup.couponCodeData?.discountName,
                    discountValue: this._signup.couponCodeDiscount,
                };
            } else {
                couponObj = {};
            }


            // if (
            //     this._signup.selectedLocationsAndRegistersList &&
            //     this._signup.selectedLocationsAndRegistersList.length > 0
            // ) {
            //     if (
            //         this._signup.selectedLocationsAndRegistersList.filter(
            //             (v) => v.id === 1
            //         )[0] !== undefined
            //     ) {
            //         noOfRegisters =
            //             this._signup.selectedLocationsAndRegistersList.filter(
            //                 (v) => v.id === 1
            //             )[0]?.quantity || 1;
            //     }
            //     if (
            //         this._signup.selectedLocationsAndRegistersList.filter(
            //             (v) => v.id === 2
            //         )[0] !== undefined
            //     ) {
            //         noOfLocations =
            //             this._signup.selectedLocationsAndRegistersList.filter(
            //                 (v) => v.id === 2
            //             )[0]?.quantity || 1;
            //     }
            // }

            subscriptionPlanPkg = subscriptionPlanPkg.concat(hardwareList);
            let businessID = null;
            let userID = null;

            if (
                this._signup.businessInfo === null ||
                this._signup.businessInfo.businessId === 0
            ) {
                businessID = this._globals.userInfo.businessSetup[0].businessId;
                userID = this._globals.userInfo.businessSetup[0].userID;
                this._signup.businessInfo = {
                    businessId:
                        this._globals.userInfo.businessSetup[0].businessId,
                    userID: this._globals.userInfo.businessSetup[0].userID,
                    companyName:
                        this._globals.userInfo?.businessSetup[0]
                            .businessDisplayName,
                    businessName:
                        this._globals.userInfo?.businessSetup[0]
                            .businessDisplayName,
                    industryTypeId: 0,
                    phone: this._globals.userInfo?.phone,
                    email: this._globals.userInfo?.email,
                    address: '',
                    zip: '',
                    city: '',
                    state: 'Alabama',
                    selectedState: null,
                    industry: 0,
                };
            } else if (this._signup.businessInfo?.businessId !== null) {
                businessID = this._signup.businessInfo.businessId;
                userID = this._signup.businessInfo.userID;
            } else {
                {
                    businessID = this._signup.businessData.businessId;
                    userID = this._signup.businessData.userID;
                }
            }
            this.saveBusinessInfo();

            const subscriptionAddons = [];

            if(this._signup.selectedPlans[0].addons?.length){
                this._signup.selectedPlans[0].addons.forEach((v) => {
                    if (v.selected) {
                       const price=  this._signup.selectedPlanInterval === 'Yearly'
                        ? v.yearlyPrice * 12
                        : v.monthlyPrice ;

                        let taxAmount = this.calcTax(price);
                        const grandTotal = price + taxAmount;
                        subscriptionPlanPkg.push({
                            name: v.planName,
                            reOccurring: true,
                            oneTimePrice: 0,
                            packageId: v.id.toString(),
                            qty: 1,
                            pricePerPackage: this._signup.selectedPlanInterval === 'Yearly'
                        ? v.yearlyPrice.toFixed(2)
                        : v.monthlyPrice.toFixed(2),
                            subTotalCost: price.toFixed(2),
                            packageType: 0,
                            discountValue: 0,
                            taxValue: this.taxRate,
                            discountAmount: 0,
                            taxAmount: taxAmount.toFixed(2),
                            isDiscountPercent: false,
                            isTaxPercent: false,
                            totalPrice: price.toFixed(2),
                            isAddon: true,
                        });
                    }
                });
            }

            let data = {
                businessId: businessID,
                NoOfLocations: noOfRegisters,
                PerNoOfRegister: 1,
                NoOfRegisters: noOfLocations,
                userID: userID,
                SaveInfo: true,
                subscription: {
                    TransactionDetails: TransactionDetails,
                    hardwarePkgId: '',
                    totalHardwarePkgCost: this.totalHaredwarePrice
                        .toFixed(2)
                        .toString(),
                    totalSupportPkgCost: '0',
                    planCost: '0',
                    planId: 12345678,
                    totalCost: this.grandTotal.toFixed(2).toString(),
                    subscriptionPlanPkg: subscriptionPlanPkg,
                    SubscriptionsPlanV2: subscriptionPlanPkg,
                    WooCommercePlanPkg: [],
                    DomainPlanPkg: [],
                    hardwarePkg: [],
                    TotalTaxAmount: this.taxAmount.toFixed(2).toString(),
                    subTotalCost: this.subTotal.toFixed(2).toString(),
                    TotalDiscountAmount: this._signup.couponCodeDiscount,
                    TotalTaxValue: this.taxRate,
                    TotalDiscountValue: 0,
                    IsTotalTaxPercente: true,
                    IsTotalDiscountPercent: false,
                    SubscribedFeatures: [],
                },
                CCCustomerProfile: CCCustomerProfile,
                DiscountDet: couponObj,
                CouponCode: this._signup.couponCodeData?.couponCodes || null,
                SuccessUrl: `${websiteDomain}/#/signup/subscription-payment-success`,
                FailureUrl: `${websiteDomain}/#/signup/check-out`,
            };
            sessionStorage.setItem("checkout-stripe-subscription", JSON.stringify(data));
            sessionStorage.setItem("checkout-signup-subscription", JSON.stringify(this._signup.selectedPlans));
            sessionStorage.setItem('is-form-loaded', 'yes');


            this._signup.checkoutPageInfo = data;
            this._spinner.show();
            this._signup
                .saveUserSignupInfoV2(data)
                .pipe(retry(3))
                .subscribe(
                    (res) => {
                        sessionStorage.setItem(
                            'user-Info',
                            JSON.stringify(this._signup.personalInfo)
                        );
                        if (res.success && res.responseStatusCode == 903) {
                            //   if(res.success){
                            this._signup
                                .saveUserSignupInfoForStripeV2(data)
                                .pipe(retry(3))
                                .subscribe((data) => {
                                    //    if(data.success){
                                    let session = {
                                        publicKey: data.publicKey,
                                        sessionId: data.sessionId,
                                    };
                                    this.redirectToCheckout(session);
                                });
                        }
                    },
                    (error) => {
                        this._connMessageService.showToastMessage(
                            error.message,
                            'error'
                        );
                        this._spinner.hide();
                    }
                );
        } catch (error) {
            this._connMessageService.showToastMessage(error.message, 'error');
            this._spinner.hide();
        }
    }
    redirectToCheckout(session: any) {
        let url = window.location.origin + '/#/signup/check-out';
        localStorage.setItem('goto', url);
        const stripe = Stripe(session.publicKey);
        stripe?.redirectToCheckout({
            sessionId: session.sessionId,
        });
    }

    saveBusinessInfo() {
        this._signup.businessInfo.address = this.bf?.address.value;
        this._signup.businessInfo.zip = this.bf?.zipCode.value;
        this._signup.businessInfo.city = this.bf?.city.value;
        this._signup.businessInfo.state = this.selectedState?.abbreviation;
        this._signup
            .saveBusinessInfoV2(this._signup.businessInfo)
            .subscribe((res) => {
                return res;
            });
    }

    previousPage(){

        this.setSessionValues()
        sessionStorage.setItem('back-to-personal', 'yes');
        this._router.navigate(['signup/personal-info']);
    }

    setSessionValues(){
        sessionStorage.setItem("checkout-signup-subscription", JSON.stringify(this._signup.selectedPlans));
        this._signup.selectedPlans = this._signup.selectedPlans;
            this._signup.additionalEquipment =
                this._signup.selectedLocationsAndRegistersList;

            sessionStorage.setItem(
                'selected-hardwares',
                JSON.stringify(this._signup.selectedHardware)
            );
            sessionStorage.setItem(
                'registersAndLocationsList',
                JSON.stringify(this.registersAndLocationsList)
            );
            sessionStorage.setItem(
                'selected-additional-loc-reg',
                JSON.stringify(this._signup.additionalEquipment)
            );
            sessionStorage.setItem(
                'grandTotal',
                JSON.stringify(this.grandTotal)
            );
            sessionStorage.setItem(
                'interval',
                JSON.stringify(this._signup.selectedPlanInterval)
            );
            sessionStorage.setItem(
                'address',
                JSON.stringify(this.addressForm.value)
            );
            if (!this.isShowHardware) {
                sessionStorage.setItem('allowHardware', 'No');
            } else {
                sessionStorage.removeItem('allowHardware');
            }
            if (this.isBusinessAddressisShippingAddress === false) {
                sessionStorage.setItem(
                    'shipping',
                    JSON.stringify(this.shippingForm.value)
                );
            } else {
                sessionStorage.removeItem('shipping');
            }
    }

    logout() {
        const confirmed = confirm('Are you sure you want to log out?');
        if (confirmed) {
            localStorage.removeItem('user-Verified')
            localStorage.removeItem('user')
            sessionStorage.clear()
            this._router.navigate(['pages/signin'])
        }

    }

    onPricingOptionChange(value: string, hardware: any): void {

        if (hardware) {
            hardware.selectedPricingOption = value;
            setTimeout(() => {
                this.calculate();
            }, 300);
        }
    }

    showTerms() {
        window.open('https://lincsell.com/terms-of-service/','_blank')
     }

     showEndUserAggreement() {
       window.open('https://lincsell.com/privacy-policy/','_blank')
     }

     cancel(){
        if(this._signup.accountVerified){
            const confirmed = confirm('Are you sure you want to leave signup this will log you out?');
            if (confirmed) {
                localStorage.removeItem('user-Verified')
                localStorage.removeItem('user')
                sessionStorage.clear()
                window.location.href = 'https://lincsell.com/';
            }
        }
        else{
            window.location.href = 'https://lincsell.com/';
        }
    }
}
